<!-- This example requires Tailwind CSS v2.0+ -->
<template>

    <page-heading :page-title="'Sklepy'"/>

    <div class="bg-white">
        <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
                <div v-if="name === null">
                    <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">Kompleksowa oferta</h2>
                    <p class="mt-3 max-w-3xl text-lg text-gray-500 font-bold">Główną gałęzią naszej działalności są
                        supermarkety zrzeszone w polskiej sieci handlowej Euro Sklep.</p>
                    <p class="mt-3 max-w-3xl text-md text-gray-500"> Prowadzimy także sklepy z produktami dla dzieci i
                        dla domu. Dostarczamy produkty firmy Ikea do Bielska-Białej.</p>
                    <p class="mt-3 max-w-3xl text-md text-gray-500">W ramach działalności usługowej oferujemy usługi
                        pocztowe, druku i składania dokumentów oraz kantor wymiany walut.</p>
                    <p class="mt-3 max-w-3xl text-md text-gray-500">Od 2022 roku rozszerzamy ofertę o produkty
                        gastronomiczne, przygotowywane codziennie przez naszych kucharzy. Oferujemy ciepłe dania do
                        nabycia w sklepach, z dostawą do domu oraz obsługę cateringową. </p>


                    <div class="relative py-3">
                        <div class="absolute inset-0 flex items-center" aria-hidden="true">
                            <div class="w-full border-t border-gray-300"/>
                        </div>
                        <div class="relative flex justify-center uppercase font-bold">
                            <span
                                class="px-2 bg-white text-sm text-indigo-500"> Wybierz markę i poznaj szczegóły  </span>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">{{ name }}</h2>
                    <p class="mt-3 max-w-3xl text-md text-gray-500" v-if="address">{{ address }}</p>

                    <div class="mt-1 mb-3" v-if="tags">
                        <span v-for="tag in tags">
                          <span style="font-size: 10px"
                                class="m-1 uppercase inline-flex items-center px-2 py-0.5 rounded font-medium bg-indigo-100 text-indigo-800">
                            <svg class="mr-1.5 h-2 w-2 text-indigo-400" fill="currentColor" viewBox="0 0 8 8">
                              <circle cx="4" cy="4" r="3"/>
                            </svg>
                            {{ tag }}
                          </span>
                        </span>
                    </div>

                    <div class="py-4" v-if="whs">
                        <div class="pb-0.5" v-for="wh in whs" :key="wh.id">
                            <div
                                class="relative inline-flex items-center rounded-full border border-gray-300 px-3 py-0.5 text-sm">
                          <span class="absolute flex-shrink-0 flex items-center justify-center">
                            <span class="h-1.5 w-1.5 rounded-full"
                                  :class="wh?.temporary ? 'bg-red-500' : 'bg-indigo-500'" aria-hidden="true"></span>
                              <!--                            <span class="h-1.5 w-1.5 rounded-full" :class="{'bg-red-500': wh.temporary, 'bg-indigo-500': wh.temporary==false}" aria-hidden="true"></span>-->
                          </span>
                                <span class="ml-3.5 font-medium text-gray-900">{{ wh.title }}: {{ wh.hours }}</span>
                            </div>
                        </div>
                    </div>

                    <p class="mt-3 max-w-3xl text-lg text-gray-500" v-html="description"></p>

                    <p class="mt-3 text-lg text-indigo-500 font-bold">Oferta</p>
                    <p class="mt-1 max-w-3xl text-md text-gray-500" v-html="offer"></p>


                    <p v-if="localization" class="mt-3 text-lg text-indigo-500 font-bold">Lokalizacja</p>
                    <p v-if="localization" class="mt-1 max-w-3xl text-md text-gray-500" v-html="localization"></p>


                    <div class="mt-8 sm:flex">
                        <a :href="`tel:${phone}`"
                           class="my-0.5 flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 rounded-md shadow">Zadzwoń</a>
                        <a v-if="www" :href="`https://${www}`"
                           class="sm:ml-2 my-0.5 flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-200 hover:bg-indigo-300 rounded-md shadow">Strona
                            internetowa</a>
                    </div>


                    <div v-if="depId===6">
                        <Currency/>
                    </div>

                </div>
                <div class="mt-8 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-0 lg:grid-cols-2">
                    <div v-for="department in departments" :key="department.id"
                         class="col-span-1 flex justify-center py-8 px-8 bg-gray-50 cursor-pointer"
                         @click="$router.push({ name: 'shops', params: { id: department.id } })">
                        <img class="max-h-32" :src="department.logo_src" :alt="department.name"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeading from "../components/layout/PageHeading";
import Currency from "../components/sections/Currency";

let departments
export default {
    name: "ShopsPage",
    components: {Currency, PageHeading},
    props: ['id'],
    data: () => ({
        depId: null,
        name: null,
        address: null,
        phone: null,
        description: null,
        offer: null,
        localization: null,
        www: null,
        logo_src: null,
        tags: null,
        departments: []
    }),
    created: function () {
        this.getDepartments();
        if (this.id) {
            this.fetchDescription(this.id);
        }
    },
    watch: {
        id(newDepartmentId, oldDepartmentId) {
            this.fetchDescription(newDepartmentId);
        }
    },
    methods: {
        async fetchDescription(id) {
            await fetch(`https://cloudpanel.pl/api/uchowanca/departmentDescription/${id}`)
                .then(response => response.json())
                .then(result => {
                    this.depId = result.result.id;
                    this.name = result.result.name;
                    this.address = result.result.address;
                    this.phone = result.result.phone;
                    this.description = result.result.description;
                    this.offer = result.result.offer;
                    this.localization = result.result.localization;
                    this.www = result.result.www;
                    this.logo_src = result.result.logo_src;
                    this.tags = result.result.tags;
                    this.whs = result.result.workingHours;
                });
        },
        async getDepartments() {
            await fetch(`https://cloudpanel.pl/api/uchowanca/departments`)
                .then(response => response.json())
                .then(result => {
                    this.departments = result.departments;
                    console.log(result.departments)
                });
        }
    }
}
</script>

<style scoped>

</style>
